import { render, staticRenderFns } from "./group.mpx?vue&type=template&id=2c3b9b3c&isComponent&outputPath=components%2Fgroup136546f0%2Findex"
import script from "./group.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fgroup136546f0%2Findex"
export * from "./group.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fgroup136546f0%2Findex"
import style0 from "./group.mpx?vue&type=style&index=0&id=2c3b9b3c&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_136546f0%22%7D&isComponent&outputPath=components%2Fgroup136546f0%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports